type Radius = 'straight' | 'soft' | 'rounded'

function setRadius(radius: Radius) {
    document.documentElement.setAttribute('data-radius', radius)
}

export const radiusModel = {
    setRadius,
}
